// store/modules/bluetooth.js
import moment from 'moment-timezone';
moment.locale('id');

function formatTextColonCenter(paperWidth, title, value,isColon = true) {
    const colon = (isColon) ? ' : ':'   ';
    const colonCenter = Math.floor(paperWidth / 2);
    const leftWidth = colonCenter - Math.ceil(colon.length / 2);
    const rightWidth = paperWidth - colonCenter - Math.floor(colon.length / 2);

    const leftPart = title.length > leftWidth
        ? title.slice(0, leftWidth)
        : title.padEnd(leftWidth, ' ');

    const rightPart = value.length > rightWidth
        ? value.slice(0, rightWidth)
        : value.padStart(rightWidth, ' ');

    return leftPart + colon + rightPart;
}
// function formatTextRight(paperWidth, text) {
//     return text.length >= paperWidth
//         ? text.slice(0, paperWidth) // truncate if too long
//         : ' '.repeat(paperWidth - text.length) + text;
// }

function formatText(paperWidth, title, value) {
    return `${title}` + " ".repeat(paperWidth - title.length - value.length) + value;
}

function formatExhibitionDateRange(startDate, endDate) {
    const start = moment(startDate);
    const end = moment(endDate);

    if (start.isSame(end, 'month')) {
        // Same month → only show day for start
        return `${start.format("D")} - ${end.format("D MMMM YYYY")}`;
    } else {
        // Different months → show full format for both
        return `${start.format("D MMMM")} - ${end.format("D MMMM YYYY")}`;
    }
}

function normalizeAndWrap(text, width) {
    const s = String(text);
    // 1) Replace any backslash+N or backslash+n (escaped as \\N or \\n) with a real newline
    const withNewlines = s.replace(/\\[nN]/g, '\n');

    // 2) Split on real newlines, wrap each chunk, then rejoin
    return withNewlines
        .split(/\r?\n/)
        .map(para => wrapText(para, width))
        .join('\n');
}
function wrapText(text, width = 48) {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    for (const word of words) {
        // if adding this word would exceed width, flush current line
        if ((line + word).length > width) {
            if (line) lines.push(line.trim());
            line = word + ' ';
        } else {
            line += word + ' ';
        }
    }
    if (line) lines.push(line.trim());
    return lines.join('\n');
}
// function wrapMultilineField(title, value, width = 48) {
//     const valueStr = String(value);
//     const lines = [];

//     // First line: just the title and colon
//     lines.push(`${title}:`);

//     // Wrap the value into lines of max `width` characters
//     for (let i = 0; i < valueStr.length; i += width) {
//         lines.push(valueStr.substring(i, i + width));
//     }

//     return lines.join('\n') + '\n';
// }

function CheckPaymentStatus(grandTotal, PayTotal) {
    if (PayTotal < grandTotal && grandTotal > 0 && PayTotal > 0) {
        return "DP";
    } else if (PayTotal == grandTotal) {
        return "LUNAS";
    } else if (PayTotal > grandTotal) {
        return "LEBIH BAYAR";
    } else if (PayTotal == 0) {
        return "BELUM BAYAR";
    } else {
        return "-";
    }
}

function changeOrderNoFormat(orderNo, exhibId) {
    return "#" + `${exhibId}`.padStart(5, "0") + " " + orderNo.replaceAll("DC_", "").replaceAll("GMB_", "");
}
function hitungTotal(details) {
    let totalDetail1 = details.reduce((acc, val) => {
        let harga = 0;

        if (val.OrderPrice > 0) {
            harga = val.OrderPrice;
        } else if (!val.ToNote) {
            harga = (val.ExtraDiscountNote?.Price ?? 0);
        } else {
            harga = 0;
        }

        const subtotal = (val.OrderQty * harga);
        return acc + subtotal;

    }, 0);
    let totalDetail2 = 0;
    // details2.reduce((acc, val) => {
    //     let harga = val.price ?? 0;
    //     const subtotal = (val.Qty * harga);
    //     return acc + subtotal;

    // }, 0);

    return (totalDetail1 + totalDetail2).toLocaleString("id-ID");
}
function hitungTotalDisc(details1) {
    let totalDetail1 = details1.reduce((acc, val) => {
        let harga = val.OrderPrice;
        let subTotal = 0;
        if (val.OrderPrice == 0) {
            if (!val.ToNote) {
                harga = (val.ExtraDiscountNote?.Price ?? 0);
            }
            subTotal = (val.OrderQty * harga);
        } else {
            subTotal = val.OrderDiscount ?? 0;
        }

        return acc + subTotal;

    }, 0);
    let totalDetail2 = 0;
    // details2.reduce((acc, val) => {
    //     let harga = val.price ?? 0;
    //     const subtotal = (val.Qty * harga);
    //     return acc + subtotal;

    // }, 0);
    return (totalDetail1 + totalDetail2).toLocaleString("id-ID");
}

const state = {
    characteristic: null,
    printerName: "",
    printerStatus: "KONEKSI TERPUTUS",
};

const mutations = {
    SET_CHARACTERISTIC(state, characteristic) {
        state.characteristic = characteristic;
    },
    SET_PRINTER_NAME(state, name) {
        state.printerName = name;
    },
    SET_PRINTER_STATUS(state, status) {
        state.printerStatus = status;
    }
};

const actions = {
    async connectPrinter({ commit }) {
        try {
            const device = await navigator.bluetooth.requestDevice({
                acceptAllDevices: true,
                optionalServices: [0x18f0]
            })

            commit('SET_PRINTER_NAME', device.name);
            const server = await device.gatt.connect();

            const service = await server.getPrimaryService(0x18f0);
            const characteristic = await service.getCharacteristic(0x2af1);

            commit('SET_CHARACTERISTIC', characteristic);
            commit('SET_PRINTER_STATUS', "TERHUBUNG");

            // setInterval(() => {
            //     console.log(device.gatt.connected ? "Connected" : "Disconnected");
            // }, 300000); 5 minute

            // Listen for disconnection
            device.addEventListener("gattserverdisconnected", () => {
                commit('SET_PRINTER_NAME', "");
                commit('SET_CHARACTERISTIC', null);
                commit('SET_PRINTER_STATUS', "KONEKSI TERPUTUS");
            });

            setInterval(() => {
                commit('SET_PRINTER_STATUS', "Memeriksa Koneksi...");
                console.log(device.gatt.connected ? "SET_PRINTER_STATUS: Connected" : "SET_PRINTER_STATUS: Disconnected");
                commit('SET_PRINTER_STATUS', device.gatt.connected ? "TERHUBUNG" : "KONEKSI TERPUTUS");
            }, 60000); // 60000 ms = 1 minute

            return characteristic;
        } catch (error) {
            commit('SET_PRINTER_NAME', "");
            commit('SET_CHARACTERISTIC', null);
            commit('SET_PRINTER_STATUS', "KONEKSI TERPUTUS");
            throw new Error(`Printer Error: ${error}`);
        }
    },
    generateReceipt(_, { dataList, order, name }) {
        const PAPER_WIDTH = 48; // 80mm paper width

        let receipt = "";
        receipt += "\x1B\x40";
        receipt += "\x1B\x32";
        receipt += "\x1B\x61\x01" + dataList.ExhibitionOtherName;

        if (name == '*** CUSTOMER COPY ***' && order.CompanyPhoneNumber && order.CompanyPhoneNumber != undefined && order.CompanyPhoneNumber != null && order.CompanyPhoneNumber != "") receipt += "\n" + normalizeAndWrap((order.CompanyPhoneNumber ?? " "), PAPER_WIDTH);

        receipt += "\x1B\x61\x01" + "\n" + formatExhibitionDateRange(dataList.ExhibitionStartDate, dataList.ExhibitionEndDate) + "\n";
        receipt += "\x1B\x61\x00\n";

        receipt += formatText(PAPER_WIDTH, changeOrderNoFormat(dataList.OrderNo, dataList.MasterExhibitionId), moment(order.OrderDate).format("DD-MM-YYYY")) + "\n";
        receipt += formatTextColonCenter(PAPER_WIDTH, "PELANGGAN", dataList.CustomerName) + "\n";
        receipt += formatTextColonCenter(PAPER_WIDTH, "SPG", dataList.SpgName) + "\n";
        receipt += formatTextColonCenter(PAPER_WIDTH, dataList.HandCarry, moment(order.ShipDate).format("DD-MM-YYYY")) + "\n";
        receipt += "-".repeat(PAPER_WIDTH) + "\n";

        if (['*** CUSTOMER COPY ***', '*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***'].includes(name)) {
            order.Details.filter(x => !x.ToNote).forEach(item => {
                let combineItemName = `${item.OrderIsRaft ? '[+R] ' : ''}${(item.OrderPrice === 0) ? '* ' : ''}${item.MasterItemLongDesc}`;
                const unitPrice = (item.OrderPrice > 0) ? item.OrderPrice : (!item.ToNote) ? item.ExtraDiscountNote.Price : 0;
                const totalPrice = (item.OrderQty * unitPrice).toLocaleString("id-ID");
                const quantityText = `${item.OrderQty} x ${unitPrice.toLocaleString("id-ID")}`;
                const space = PAPER_WIDTH - quantityText.length - totalPrice.length;
                receipt += `${wrapText(combineItemName)}\n`

                receipt += formatTextColonCenter(PAPER_WIDTH, quantityText.padEnd(quantityText.length + space, " "), (item.OrderPrice > 0) ? totalPrice : (item.OrderQty * ((!item.ToNote) ? item.ExtraDiscountNote.Price : 0)).toLocaleString("id-ID")) + "\n";
            });
        } else {
            order.Details.filter(x => !x.ToNote).forEach(item => {
                let combineItemName = `[${item.OrderQty}x]${item.OrderIsRaft ? '[+R]' : ''} ${(item.OrderPrice === 0) ? '* ' : ''}${item.MasterItemLongDesc}`;
                receipt += `${wrapText(combineItemName)}\n`;
            });
        }

        if (['*** CUSTOMER COPY ***', '*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***'].includes(name)) {
            receipt += "-".repeat(PAPER_WIDTH) + "\n";
            const totalText = `${(order.Details.reduce((acc, val) => acc + (val.OrderQty * ((val.OrderPrice > 0) ? val.OrderPrice : (!val.ToNote) ? val.ExtraDiscountNote.Price : 0)), 0)).toLocaleString("id-ID")}`;
            const totalTextGrand = `${order.OrderGrandTotal.toLocaleString("id-ID")}`;
            const totalTextRakit = `${order.OrderCost1.toLocaleString("id-ID")}`;
            const totalTextOngkir = `${order.OrderCost2.toLocaleString("id-ID")}`;
            const totalTextLainLain = `${order.OrderCost3.toLocaleString("id-ID")}`;
            const totalTextDisc = `${order.OrderDiscount.toLocaleString("id-ID")}`;
            const totalTextDiscItem = order.Details.filter(x => x.OrderPrice == 0).reduce((acc, val) => acc + (val.OrderQty * ((!val.ToNote) ? val.ExtraDiscountNote.Price : 0)), 0);

            receipt += formatTextColonCenter(PAPER_WIDTH, "Total", totalText) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "B. Rakit", totalTextRakit) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "B. Ongkir", totalTextOngkir) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "B. Lain-lain", totalTextLainLain) + "\n";

            if (totalTextDiscItem > 0) receipt += formatTextColonCenter(PAPER_WIDTH, `* Diskon`, totalTextDiscItem.toLocaleString("id-ID")) + "\n";
            if (totalTextDisc > 0) receipt += formatTextColonCenter(PAPER_WIDTH, "Diskon", totalTextDisc) + "\n";

            receipt += " ".repeat(PAPER_WIDTH / 2) + "=".repeat(PAPER_WIDTH / 2) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "Grand Total", totalTextGrand) + "\n";

            if (order.Pays.length > 0) receipt += "\n";

            order.Pays.forEach(item => {
                receipt += formatTextColonCenter(PAPER_WIDTH, item.PaymentMethodName ?? "METODE PEMBAYARAN", `${(item.PaymentAmount).toLocaleString("id-ID")}`) + "\n";
            });

            if (order.Pays.length > 0) receipt += "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "Sisa Pembayaran", `${(order.OrderGrandTotal - order.OrderPayTotal).toLocaleString("id-ID")}`) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "Status Pembayaran", CheckPaymentStatus(order.OrderGrandTotal, order.OrderPayTotal)) + "\n";
        }

        receipt += "-".repeat(PAPER_WIDTH) + "\n";

        receipt += "\x1B\x61\x01";
        if (['*** CUSTOMER COPY ***'].includes(name)) receipt += "Terima Kasih!\n";
        receipt += moment().format("DD-MM-YYYY HH:mm:ss") + "\n";
        receipt += name + "\n";

        if (order.Details.filter(x => x.ToNote).length != 0) {
            receipt += "-".repeat(PAPER_WIDTH) + "\n";
            receipt += "\x1B\x61\x00";
            let vocDetails = "";

            if (order.Details.filter(x => x.ToNote).length != 0) {
                order.Details.filter(x => x.ToNote).forEach(item => {
                    vocDetails += `[${item.MasterItemLongDesc} x ${item.OrderQty}]`;
                    vocDetails += " ";
                });
            }

            receipt += wrapText("Keterangan:") + "\n";
            if (vocDetails != "") receipt += wrapText(vocDetails) + "\n";
        }

        if ((['*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***', '*** GUDANG COPY ***'].includes(name))) {
            if (order.OrderNote && order.OrderNote != undefined && order.OrderNote != null && order.OrderNote != "") {
                receipt += "-".repeat(PAPER_WIDTH) + "\n";
                receipt += "\x1B\x61\x00";
                receipt += wrapText("Catatan:") + "\n";
                receipt += wrapText(order.OrderNote) + "\n";
            }

            if (dataList.HandCarry == 'DELIVERY') {
                receipt += "-".repeat(PAPER_WIDTH) + "\n";
                receipt += "\x1B\x61\x00";
                receipt += wrapText("Nama Penerima: " + order.CustomerName) + "\n";
                receipt += wrapText("No Hp: " + order.CustomerPhone) + "\n";
                receipt += wrapText("Alamat: " + order.CustomerAddress) + "\n";
                receipt += "-".repeat(PAPER_WIDTH) + "\n";
            }
        }

        receipt += "\n";
        // receipt += "\x1B\x64\x02"; // Add 1 blank lines before cutting
        receipt += "\x1B\x33\x10"; // Increase line spacing before cut
        receipt += "\x1D\x56\x42\x00"; // Cut the paper
        return receipt;
    },

    generateReceiptPRJ(_, { dataList, order, name }) {
        const PAPER_WIDTH = 48; // 80mm paper width

        let receipt = "";
        receipt += "\x1B\x40";
        receipt += "\x1B\x32";
        receipt += "\x1B\x61\x01" + dataList.ExhibitionOtherName;

         if (name == '*** CUSTOMER COPY ***' && dataList.MasterCompanyId != 2 && order.CompanyPhoneNumber && order.CompanyPhoneNumber != undefined && order.CompanyPhoneNumber != null && order.CompanyPhoneNumber != "") receipt += "\n" + normalizeAndWrap((order.CompanyPhoneNumber ?? " "), PAPER_WIDTH);

        receipt += "\x1B\x61\x01" + "\n" + formatExhibitionDateRange(dataList.ExhibitionStartDate, dataList.ExhibitionEndDate) + "\n";
        receipt += "\x1B\x61\x00\n";

        receipt += formatText(PAPER_WIDTH, changeOrderNoFormat(dataList.OrderNo, dataList.MasterExhibitionId), moment(order.OrderDate).format("DD-MM-YYYY")) + "\n";
        receipt += formatTextColonCenter(PAPER_WIDTH, "PELANGGAN", dataList.CustomerName) + "\n";
        receipt += formatTextColonCenter(PAPER_WIDTH, "SPG", dataList.SpgName) + "\n";
        receipt += formatTextColonCenter(PAPER_WIDTH, dataList.HandCarry, moment(order.ShipDate).format("DD-MM-YYYY")) + "\n";
        receipt += "-".repeat(PAPER_WIDTH) + "\n";

        if (['*** CUSTOMER COPY ***', '*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***'].includes(name)) {
            order.Details.filter(x => !x.ToNote).forEach(item => {
                let combineItemName = `${item.OrderIsRaft ? '[+R] ' : ''}${(item.OrderPrice === 0 || ((item.OrderQty * item.OrderPrice) - item.OrderDiscount) == 0) ? '* ' : ''}${item.MasterItemLongDesc}`;
                const unitPrice = (item.OrderPrice > 0) ? item.OrderPrice : (!item.ToNote) ? item.ExtraDiscountNote.Price : 0;
                const totalPrice = (item.OrderQty * unitPrice).toLocaleString("id-ID");
                const quantityText = `${item.OrderQty} x ${unitPrice.toLocaleString("id-ID")}`;
                const space = PAPER_WIDTH - quantityText.length - totalPrice.length;
                receipt += `${wrapText(combineItemName)}\n`

                receipt += formatTextColonCenter(PAPER_WIDTH, quantityText.padEnd(quantityText.length + space, " "), (item.OrderPrice > 0) ? totalPrice : (item.OrderQty * ((!item.ToNote) ? item.ExtraDiscountNote.Price : 0)).toLocaleString("id-ID")) + "\n";
            });

            order.Details2.filter(x => !x.ToNote).forEach(item => {
                let combineItemName = `* ${item.RewardName}`;
                // const unitPrice = item.price;
                // const totalPrice = (item.Qty * item.price).toLocaleString("id-ID");
                // const quantityText = `${item.Qty} x ${unitPrice.toLocaleString("id-ID")}`;
                const quantityText = `${item.Qty}x`;
                const space = PAPER_WIDTH - quantityText.length;
                receipt += `${wrapText(combineItemName)}\n`

                receipt += formatTextColonCenter(PAPER_WIDTH, quantityText.padEnd(quantityText.length + space, " "),"").toLocaleString("id-ID") + "\n";
            });
        } else {
            order.Details.filter(x => !x.ToNote).forEach(item => {
                let combineItemName = `[${item.OrderQty}x]${item.OrderIsRaft ? '[+R]' : ''} ${(item.OrderPrice === 0 || ((item.OrderQty * item.OrderPrice) - item.OrderDiscount) == 0) ? '* ' : ''}${item.MasterItemLongDesc}`;
                receipt += `${wrapText(combineItemName)}\n`;
            });
            order.Details2.filter(x => !x.ToNote).forEach(item => {
                let combineItemName = `[${item.Qty}x] *${item.RewardName}`;
                receipt += `${wrapText(combineItemName)}\n`;
            });
        }

        if (['*** CUSTOMER COPY ***', '*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***'].includes(name)) {
            receipt += "-".repeat(PAPER_WIDTH) + "\n";
            const totalText = hitungTotal(order.Details);
            const totalTextGrand = `${order.OrderGrandTotal.toLocaleString("id-ID")}`;
            const totalTextRakit = `${order.OrderCost1.toLocaleString("id-ID")}`;
            const totalTextOngkir = `${order.OrderCost2.toLocaleString("id-ID")}`;
            const totalTextLainLain = `${order.OrderCost3.toLocaleString("id-ID")}`;
            const totalTextDisc = `${order.OrderDiscount.toLocaleString("id-ID")}`;
        
            // const totalTextDiscItem = hitungTotalDisc(order.Details,order.Details2);
            const totalTextDiscItem = hitungTotalDisc(order.Details);

            receipt += formatTextColonCenter(PAPER_WIDTH, "Total", totalText) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "B. Rakit", totalTextRakit) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "B. Ongkir", totalTextOngkir) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "B. Lain-lain", totalTextLainLain) + "\n";

            if (totalTextDiscItem > 0) receipt += formatTextColonCenter(PAPER_WIDTH, `* Diskon`, totalTextDiscItem.toLocaleString("id-ID")) + "\n";
            if (totalTextDisc > 0) receipt += formatTextColonCenter(PAPER_WIDTH, "Diskon", totalTextDisc) + "\n";

            receipt += " ".repeat(PAPER_WIDTH / 2) + "=".repeat(PAPER_WIDTH / 2) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "Grand Total", totalTextGrand) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "(Termasuk PPN)", "",false) + "\n";

            order.Pays.forEach(item => {
                receipt += formatTextColonCenter(PAPER_WIDTH, item.PaymentMethodName ?? "METODE PEMBAYARAN", `${(item.PaymentAmount).toLocaleString("id-ID")}`) + "\n";
            });

            if (order.Pays.length > 0) receipt += "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "Sisa Pembayaran", `${(order.OrderGrandTotal - order.OrderPayTotal).toLocaleString("id-ID")}`) + "\n";
            receipt += formatTextColonCenter(PAPER_WIDTH, "Status Pembayaran", CheckPaymentStatus(order.OrderGrandTotal, order.OrderPayTotal)) + "\n";
        }

        receipt += "-".repeat(PAPER_WIDTH) + "\n";

        receipt += "\x1B\x61\x01";
        if (['*** CUSTOMER COPY ***'].includes(name)) receipt += "Terima Kasih!\n";
        receipt += moment().format("DD-MM-YYYY HH:mm:ss") + "\n";
        receipt += name + "\n";

        if (order.Details.filter(x => x.ToNote).length != 0) {
            receipt += "-".repeat(PAPER_WIDTH) + "\n";
            receipt += "\x1B\x61\x00";
            let vocDetails = "";

            if (order.Details.filter(x => x.ToNote).length != 0) {
                order.Details.filter(x => x.ToNote).forEach(item => {
                    vocDetails += `[${item.MasterItemLongDesc} x ${item.OrderQty}]`;
                    vocDetails += " ";
                });
            }

            receipt += wrapText("Keterangan:") + "\n";
            if (vocDetails != "") receipt += wrapText(vocDetails) + "\n";
        }

        if ((['*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***', '*** GUDANG COPY ***'].includes(name))) {
            if (order.OrderNote && order.OrderNote != undefined && order.OrderNote != null && order.OrderNote != "") {
                receipt += "-".repeat(PAPER_WIDTH) + "\n";
                receipt += "\x1B\x61\x00";
                receipt += wrapText("Catatan:") + "\n";
                receipt += wrapText(order.OrderNote) + "\n";
            }

            if (dataList.HandCarry == 'DELIVERY') {
                receipt += "-".repeat(PAPER_WIDTH) + "\n";
                receipt += "\x1B\x61\x00";
                receipt += wrapText("Nama Penerima: " + order.CustomerName) + "\n";
                receipt += wrapText("No Hp: " + order.CustomerPhone) + "\n";
                receipt += wrapText("Alamat: " + order.CustomerAddress) + "\n";
                receipt += "-".repeat(PAPER_WIDTH) + "\n";
            }
        }

        receipt += "\n";
        // receipt += "\x1B\x64\x02"; // Add 1 blank lines before cutting
        receipt += "\x1B\x33\x10"; // Increase line spacing before cut
        receipt += "\x1D\x56\x42\x00"; // Cut the paper
        return receipt;
    },
    async sendChunks({ state }, data) {
        try {
            const encoder = new TextEncoder();
            const encodedData = encoder.encode(data);

            for (let i = 0; i < encodedData.length; i += 200) {
                const chunk = encodedData.slice(i, i + 200);
                await state.characteristic.writeValue(chunk);
                await new Promise(resolve => setTimeout(resolve, 50)); // Prevent buffer overflow
            }
        } catch (error) {
            throw new Error(`Send Chunks Error: ${error}`);
        }
    },

    async printReceipt({ dispatch, state }, { dataList, order, isPRJ = false }) {
        console.log(isPRJ);
        if (!state.characteristic) throw new Error("Harap Memilih Printer Terlebih Dahulu!!!");
        let copyName = ['*** CUSTOMER COPY ***', '*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***'];
        
        // let copyName = ['*** CUSTOMER COPY ***', '*** MERCHANT COPY ***', '*** SALES COUNTER COPY ***','*** GUDANG COPY ***'];
        // let copyName = ['*** CUSTOMER COPY ***'];
        if(!dataList.IsHandCarry) copyName.push('*** GUDANG COPY ***');
        for (let i = 0; i < copyName.length; i++) {
            const name = copyName[i];
            const receiptContent = await dispatch((isPRJ) ? 'generateReceiptPRJ' : 'generateReceipt', { dataList, order, name });
            await dispatch('sendChunks', receiptContent);
            if (i == 0) await new Promise(resolve => setTimeout(resolve, 5000));
        }
    },

    async testPrint({ dispatch }) {
        const testDataList = {
            "SpgName": "TEST_SPG",
            "CompanyName": "UNIT TEST",
            "CompanyCode": "UNIT_TEST",
            "ExhibitionName": "TEST_EXHIBITION_NAME",
            "ExhibitionStartDate": "2025-05-08T00:00:00",
            "ExhibitionEndDate": "2025-05-25T00:00:00",
            "ExhibitionOtherName": "TEST EXHIBITION",
            "MasterExhibitionId": 58,
            "MasterCompanyId": 3,
            "MasterUserId": 72,
            "MasterCampaignId": 11,
            "CustomerName": "SAKURA MIYAWAKI",
            "MasterCustomerId": 502,
            "OrderNo": "OHD-TEST-00000",
            "OrderDate": "2025-05-10T00:00:00",
            "OrderNote": "",
            "ShipDate": "2025-05-17T00:00:00",
            "OrderStatus": "PROSES",
            "OrderGrandTotal": 4220000.00,
            "OrderPayTotal": 0.0,
            "IsHandCarry": false,
            "HandCarry": "DELIVERY",
        };

        const testOrder = {
            CreatedAt: new Date().toISOString(),
            CustomerName: "SAKURA MIYAWAKI",
            CustomerPhone: "0812345678910",
            CustomerAddress: "Jln. Lorem Ipsum No. 10 - FEARNOT",
            OrderGrandTotal: 40000,
            OrderCost1: 5000,
            OrderCost2: 3000,
            OrderCost3: 2000,
            OrderDiscount: 1000,
            OrderPayTotal: 10000,
            Details: [
                {
                    MasterItemLongDesc: "SQUARE CHAIR NON LOGO MERAH (A)X(B)X(C)X(D)",
                    OrderPrice: 10000,
                    OrderQty: 2,
                    OrderIsRaft: true,
                },
                {
                    MasterItemLongDesc: "SQUARE CHAIR NON LOGO MERAH (A)X(B)X(C)X(D) VARIANT BUNDLE VARIANT",
                    OrderPrice: 10000,
                    OrderQty: 2,
                    OrderIsRaft: true,
                },
                {
                    MasterItemLongDesc: "SQUARE CHAIR NON LOGO MERAH (A)X(B)X(C)X(D) VARIANT BUNDLE VARIANT SQUARE CHAIR NON LOGO MERAH (A)X(B)X(C)X(D) VARIANT BUNDLE VARIANT",
                    OrderPrice: 10000,
                    OrderQty: 2,
                    OrderIsRaft: true,
                },
                {
                    MasterItemLongDesc: "MATRAS 3 IN 1 FOREST DREAM 90",
                    OrderPrice: 10000,
                    OrderQty: 2,
                    OrderIsRaft: true,
                },
                {
                    MasterItemLongDesc: "Test Item 2 - Loremp Ipsum ",
                    OrderPrice: 20000,
                    OrderQty: 1,
                    OrderIsRaft: false,
                }
            ],
            Pays: [
                {
                    PaymentAmount: 5000.00,
                    IsChangeMoney: false,
                    PaymentMethodName: "QRIS BCA"
                },
                {
                    PaymentAmount: 5000.00,
                    IsChangeMoney: false,
                    PaymentMethodName: "CASH"
                }
            ]
        };
        await dispatch('printReceipt', { dataList: testDataList, order: testOrder });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
